import type { DeployStatus } from '@/types';

/**
 * Estados de un deploy y cada cuánto refrescarlo (2026-09-26). Antes cada pantalla decidía por su
 * cuenta y sólo miraba `in_progress`/`rolling_back`: al llegar `completed` por WebSocket el
 * polling se cortaba ANTES de traer el registro final (métricas, duración, logs), y un deploy
 * abierto en `pending`/`queued` quedaba congelado hasta recargar la página.
 */
const RUNNING: ReadonlySet<DeployStatus> = new Set(['pending', 'queued', 'in_progress', 'rolling_back']);
const WAITING: ReadonlySet<DeployStatus> = new Set(['waiting_approval', 'scheduled']);
const TERMINAL: ReadonlySet<DeployStatus> = new Set(['completed', 'failed', 'cancelled', 'rolled_back']);

/** En ejecución o a punto de arrancar: WebSocket abierto y polling rápido. */
export function isDeployRunning(status?: string): boolean {
  return !!status && RUNNING.has(status as DeployStatus);
}

/** Terminó (bien o mal): ya no va a cambiar solo. */
export function isDeployTerminal(status?: string): boolean {
  return !!status && TERMINAL.has(status as DeployStatus);
}

/** Intervalo de polling para un deploy: 3 s corriendo, 10 s esperando aprobación/horario, nada si terminó. */
export function deployPollInterval(status?: string): number | false {
  if (isDeployRunning(status)) return 3000;
  if (status && WAITING.has(status as DeployStatus)) return 10000;
  return false;
}

/** Intervalo para una lista: 5 s mientras alguno de sus deploys no terminó. */
export function listPollInterval(deploys?: { status: string }[]): number | false {
  return deploys?.some((d) => !isDeployTerminal(d.status)) ? 5000 : false;
}
